import React from 'react';
import { Check } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Cercul Armoniei Interioare',
    subtitle: 'Program de 12 luni, grup sau 1 la 1',
    image: 'https://cdn.magicpatterns.com/uploads/vueKjVxPkPNPWwk131Uvms/5.png',
    benefits: ['12 cursuri integrate care îmbină medicina alopată, terapiile alternative și lucrul cu mintea într-un parcurs coerent', 'Comunitate privată de suport activ timp de 12 luni, cu acces la discuții, resurse și conexiuni reale', 'Sesiuni lunare live de monitorizare, întrebări și răspunsuri, și ajustări personalizate ale parcursului tău', 'Materiale bonus incluse: ebook-uri tematice, checklist-uri practice și maraton de suport pe WhatsApp', 'Opțional: 12 sesiuni individuale de terapie și consult medical integrativ, adaptate nevoilor tale specifice'],
    cta: 'Află mai multe despre program',
    link: 'https://psihomedicina.ro/start'
  }, {
    title: 'Cursuri din Academie',
    subtitle: 'Teme specifice, acces imediat',
    image: 'https://cdn.magicpatterns.com/uploads/jPEpseKeM4VEorbByJQQPg/3.png',
    benefits: ['Cursuri tematice aprofundate: interpretarea analizelor, homeopatie aplicată, ayurveda practică și multe altele', 'Format video accesibil, în ritmul tău propriu, fără presiune de timp sau termene limită', 'Informație medicală și terapeutică explicată în limbaj simplu, ușor de înțeles și de aplicat', 'Fiecare curs conține exerciții și instrumente aplicabile imediat în viața ta de zi cu zi', 'Parte din colecția completă de 12 cursuri, cu posibilitatea de a le parcurge individual sau ca pachet'],
    cta: 'Vezi cursurile online',
    link: 'https://psihomedicina.ro/fitoterapie'
  }, {
    title: 'Evenimente Fizice București',
    subtitle: 'Practici de transformare în grup',
    image: 'https://cdn.magicpatterns.com/uploads/cjkc8v5DmjU4HQJ72dULU9/7.png',
    benefits: ['Cercuri de transformare: meditație ghidată, respirație conștientă și eliberare emoțională profundă', 'Workshop-uri de reconectare trup-minte prin practici somatice și ritualuri terapeutice', 'Sesiuni de grup cu tehnici de psihoterapie, constelații sistemice și lucru cu energia', 'Retreat-uri de o zi cu detox emoțional, aromaterapie și practici de autocunoaștere', 'Comunitate live: spațiu sigur de împărtășire, susținere și transformare reală, față în față'],
    cta: 'Detalii în curând!',
    link: '#evenimente'
  }];
  return <section className="w-full bg-gray-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-214" data-mp="39ddlvgvpwey6">
      <div className="max-w-7xl mx-auto" data-id="element-215" data-mp="3eb5dsawd412d">
        <div className="text-center mb-16" data-id="element-216" data-mp="3e813cvsb0939">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-217" data-mp="ok0ea6xe8art">
            Modalități de a lucra cu mine
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto mb-6" data-id="element-218" data-mp="tm97n4e6heug"></div>
          <p className="text-lg text-body" data-id="element-219" data-mp="2e0vyg15ysoj0">
            Alege formatul potrivit pentru tine și pentru unde ești acum.
          </p>
        </div>

        {/* Horizontal Carousel - 3 cards side by side */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch" data-id="element-220" data-mp="24at6m4akxgm9">
          {services.map((service, index) => <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col h-full border border-soft overflow-hidden" data-id="element-221" data-mp="1zb6q9lzgfk98" data-mpi={index}>
              {/* Image at top */}
              <div className="w-full h-48 overflow-hidden" data-id="element-222" data-mp="1lcqevhqnd5kr">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300" data-id="element-223" data-mp="1gef1wy522eyb" />
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-grow" data-id="element-224" data-mp="3aqdena2kpsyy">
                <div className="mb-6" data-id="element-225" data-mp="28gd2fpjq7lrb">
                  <h3 className="text-2xl font-bold text-primary mb-2" data-id="element-226" data-mp="28d7c66zd2du0">
                    {service.title}
                  </h3>
                  <p className="text-sm font-semibold text-medium uppercase tracking-wide" data-id="element-227" data-mp="1yhdqny3nza03">
                    {service.subtitle}
                  </p>
                </div>

                <ul className="space-y-4 mb-8 flex-grow" data-id="element-228" data-mp="23hrybf1cshxl">
                  {service.benefits.map((benefit, bIndex) => <li key={bIndex} className="flex items-start space-x-3" data-id="element-229" data-mp="1tiayhe8s8y9j" data-mpi={bIndex}>
                      <span className="flex items-center justify-center w-5 h-5 rounded-full bg-primary text-white shrink-0 mt-0.5" data-id="element-230" data-mp="1fqcvll5nzylt">
                        <Check className="w-3 h-3" strokeWidth={3} data-id="element-231" data-mp="1koo15joxfmy8" />
                      </span>
                      <span className="text-body leading-snug text-sm" data-id="element-232" data-mp="15rx2xdqzoha7">
                        {benefit}
                      </span>
                    </li>)}
                </ul>

                <a href={service.link} className="w-full rounded-full bg-primary text-white font-semibold py-4 px-6 hover:bg-[#5A1D5F] transition-colors mt-auto inline-block text-center" data-id="element-233" data-mp="r4q240v7wzp1">
                  {service.cta}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}